import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightBulb: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconLightBulb"><Path d="M20 9C20 11.3899 18.952 13.5345 17.2915 15H6.70846C5.04803 13.5345 4 11.3899 4 9C4 4.58172 7.58172 1 12 1C16.4183 1 20 4.58172 20 9Z" fill="currentColor"/><Path d="M8 17.5V16H16V17.5C16 18.3284 15.3284 19 14.5 19H9.5C8.67157 19 8 18.3284 8 17.5Z" fill="currentColor"/><Path d="M9.5 21C9.22386 21 9 21.2239 9 21.5C9 21.7761 9.22386 22 9.5 22H14.5C14.7761 22 15 21.7761 15 21.5C15 21.2239 14.7761 21 14.5 21H9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightBulb;
